import {MenuItem, Select, Stack} from '@mui/material'
import React from 'react'
import ArrowSelect from '../../svg/ArrowSelect'
import {useTranslation} from 'react-i18next'

export default function NewSelectState({
  option,
  onchange,
  changeState,
  setChangeState,
  state,
  check,
  status,
}: any) {
  const handleChange = (event: any) => {
    setChangeState({value: event.target.value})
    onchange(event.target.value)
  }
  const {t} = useTranslation()

  return (
    <Stack height={'100%'} dir='ltr'>
      <Select
        inputProps={{
          sx: {
            paddingRight: '20px !important',
            padding: '0px !important',
            border: 'none !important',
          },
        }}
        disabled={check}
        IconComponent={ArrowSelect} // استبدال أيقونة السهم الافتراضية
        sx={{
          textAlign: 'center',
          padding: state ? '5px 6px' : '12.0625px 13px 12.5px',
          background:
            state && changeState.value === 'pending'
              ? '#FFC700'
              : state && changeState.value === 'preparing'
              ? '#FFAB10'
              : state && changeState.value === 'in_progress'
              ? '#009EF7'
              : state && changeState.value === 'refunded'
              ? '#f8f5ff7a'
              : state && changeState.value === 'not_active'
              ? '#5959597a'
              : state && (changeState.value === 'completed' || changeState.value === 'active')
              ? '#50CD89'
              : state && (changeState.value === 'canceled' || changeState.value === 'blocked')
              ? '#EF305E'
              : '#D81923',
          border: state ? 'none' : 'auto',
          color: '#fff',
          borderRadius: '8.18px',
          height: '100%',
          width: '100%',
          '& fieldset.MuiOutlinedInput-notchedOutline': {
            border: 'none !important',
          },
          '& .MuiSelect-icon': {
            right: '-5px', // تحريك الأيقونة أكثر لليمين
            color: '#fff', // يمكنك تغيير اللون حسب الحاجة
          },
        }}
        value={changeState.value}
        onChange={handleChange}
      >
        {option.map((e: any) => (
          <MenuItem
            style={{
              background: e.value == status ? '#00e5ff24' : 'var(--bs-app-footer-bg-color)',
              color: 'var(--bs-body-color)',
            }}
            key={e.value}
            value={e.value}
          >
            <Stack alignItems={'center'} justifyContent={'center'} gap='14px' direction={'row'}>
              {t(e.label)}
            </Stack>
          </MenuItem>
        ))}
      </Select>
    </Stack>
  )
}
